
import { defineComponent, PropType } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    theme: {
      type: Object as PropType<ITheme>,
      required: true,
    },
  },
  data() {
    return {
      tabType: 'Details',
    };
  },
  methods: {
    getResourceState(theme: ITheme) {
      return utils.getResourceState(theme.state, theme.isFeatured);
    },

    getStorageUrl(userName: string, name: string, url: string) {
      return `https://storage.sscms.com/themes/${userName}/${name}/${utils.trim(url, '/')}`;
    },
  },
  watch: {
    theme() {
      this.tabType = 'Details';
    },
  },
});
